__turbopack_context__.v({
  "around": "Row-module__CxE45q__around",
  "between": "Row-module__CxE45q__between",
  "bottom": "Row-module__CxE45q__bottom",
  "center": "Row-module__CxE45q__center",
  "component": "Row-module__CxE45q__component",
  "left": "Row-module__CxE45q__left",
  "middle": "Row-module__CxE45q__middle",
  "right": "Row-module__CxE45q__right",
  "top": "Row-module__CxE45q__top",
});
